import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    refrence: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    description: {
        width: '40%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    // rate: {
    //     width: '15%',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    // },
    amount: {
        width: '15%'
    },
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.refrence}>Booking ID</Text>
        <Text style={styles.description}>Booking Item</Text>
        <Text style={styles.qty}>Service Date</Text>
        <Text style={styles.amount}>No Travelers</Text>
        {/* <Text style={styles.rate}>@</Text>
        <Text style={styles.amount}>Amount</Text> */}
    </View>
  );
  
  export default InvoiceTableHeader